export const announcementPrioritiesApiHandler = {
  getAnnouncementPriorities: {
    method: "GET",
    path: () => `org-announcement-priorities`
  }
};